import React, { useState } from "react";
import "./changePassword.scss";
import { Card, CardBody, Label } from "reactstrap";
import { useTranslation } from "react-i18next";
import HookForm from "../../components/hookForm/hookForm";
import TextField from "../../components/textField/textField";
import Constant from "../../util/constant";
import CustomButton from "../../components/customButton/customButton";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { showToast } from "../../store/features/toast/toastSlice";
import axios from "axios";
import { CHANGE_PASSWORD } from "../../api/endPoint";
import { Helmet } from "react-helmet";

const ChangePassword: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showOldPass, setOldShowPass] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPassConfirm, setShowPassConfirm] = useState(false);
  const [formMethod, setFormMethod] = useState<any>(null);

  const changePasswordForm = {
    currentPassword: {
      name: "currentPassword",
      validate: {
        required: {
          value: true,
        },
      },
    },
    newPassword: {
      name: "newPassword",
      validate: {
        required: {
          value: true,
        },
        validate: {
          hasUppercase: (value: string) =>
            (value && value.match(Constant.REGEX.UPPERCASE) !== null) ||
            "Minimum 1 uppercase character",
          hasLowerCase: (value: string) =>
            (value && value.match(Constant.REGEX.LOWERCASE) !== null) ||
            "Minimum 1 lowercase character",
          hasNumbers: (value: string) =>
            (value && value.match(Constant.REGEX.NUMBER) !== null) ||
            "Minimum 1 numeric character",
          hasSpecialChar: (value: string) =>
            (value && value.match(Constant.REGEX.SPECIALCHARACTERS) !== null) ||
            "Minimum 1 special character",
          length: (value: string) =>
            (value && value.length >= 8 && value.length <= 16) ||
            "Minimum 8 - Maximum 16 characters long",
          noEmoji: (value: string) =>
            (value && !value.match(Constant.REGEX.EMOJI)) ||
            "Password cannot contain emojis",
        },
      },
    },
    confirmPassword: {
      name: "confirmPassword",
    },
  };

  const setForm = (method: any) => {
    setFormMethod(method);
  };

  const onChangePasswordSubmit = async (formData: any) => {
    setLoading(true);
    try {
      // Get the auth token from localStorage
      const token = localStorage.getItem("accessToken"); // Adjust based on your token storage key

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}${CHANGE_PASSWORD}`,
        {
          currentPassword: formData.currentPassword,
          newPassword: formData.newPassword,
          confirmPassword: formData.confirmPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Adjust based on your auth header format
          },
        }
      );

      dispatch(
        showToast({
          show: true,
          message: response.data.message || "Password updated successfully!",
          type: "success",
        })
      );

      if (formMethod) {
        formMethod.reset({
          currentPassword: "",
          newPassword: "",
          confirmPassword: "",
        });
      }

      setTimeout(() => {
        setLoading(false);
        // navigate('/');
      }, 2000);
    } catch (error: any) {
      if (error.response?.status === 401) {
        // Handle unauthorized access
        dispatch(
          showToast({
            show: true,
            message: "Please login to change your password",
            type: "error",
          })
        );
        navigate("/login"); // Redirect to login page
      } else {
        dispatch(
          showToast({
            show: true,
            message:
              error.response?.data?.message || "Failed to update password!",
            type: "error",
          })
        );
      }
      setLoading(false);
    }
  };

  const handleOldPasswordChange = (value: string) => {
    const trimmedValue = value.trim(); // Trim spaces
    return trimmedValue; // Return trimmed value directly
  };

  const handleConfirmPasswordChange = (value: string) => {
    const trimmedValue = value.trim(); // Trim spaces
    if (typeof window !== "undefined") {
      localStorage.setItem("confirmPassword", trimmedValue); // Save email as a plain string
    }
  };
  const multiErrorFields = [
    { length: t("PASSWORD_MUST_BE_BETWEEN_8_AND_16_CHARACTERS") },
    { hasSpecialChar: t("MINIMUM_1_SPECIAL_CHARACTER") },
    { hasNumbers: t("MINIMUM_1_NUMERIC_CHARACTER") },
    { hasUppercase: t("MINIMUM_1_UPPERCASE_CHARACTER") },
    { hasLowerCase: t("MINIMUM_1_LOWERCASE_CHARACTER") },
    { noEmoji: t("PASSWORD_CANNOT_CONTAIN_EMOJIS") },
  ];
  const handleNewPasswordChange = (value: string) => {
    const trimmedValue = value.trim(); // Trim spaces

    if (typeof window !== "undefined") {
      localStorage.setItem("newPassword", trimmedValue); // Save email as a plain string
    }
  };
  const changePasswordFunction = (form: any) => {
    // No need to set changePasswordValues here as it's not used in the component
  };
  return (
    <>
      <Helmet>
        <title>Change Password | Town of 1000 Trails Admin Panel</title>
        <meta
          name="description"
          content="Change your admin panel password at this page."
        />
      </Helmet>
      <div className="login-container changePassword-container mt-5">
        <div>
          <Card className="overflow-hidden cardStyle" color="white">
            <CardBody className="text-center px-24 py-32">
              <HookForm
                defaultForm={{ currentPassword: "" }}
                init={(method) => setForm(method)}
                onSubmit={async (formData) => {
                  onChangePasswordSubmit(formData);
                }}
              >
                {(formMethod) => {
                  return (
                    <>
                      <div className="loginWrapper mb-5">
                        <div className="texFeildWrapper mb-3">
                          <div className="d-flex">
                            <Label className="lable">
                              {t("CURRENT_PASSWORD")}
                            </Label>{" "}
                            <span className="redStar mx-2">*</span>
                          </div>
                          <div className="passWrapper">
                            <TextField
                              formMethod={formMethod}
                              rules={
                                changePasswordForm.currentPassword.validate
                              }
                              name={changePasswordForm.currentPassword.name}
                              errors={formMethod?.formState.errors}
                              autoFocus={true}
                              required={true}
                              maxLength={16}
                              disabled={loading}
                              passwordType={true}
                              type={showOldPass ? "text" : "password"}
                              placeholder={t("ENTER_CURRENT_PASSWORD")}
                              onChange={(e) => {
                                const trimmedValue = e.target.value?.trim(); // Trim spaces
                                formMethod.setValue(
                                  changePasswordForm.currentPassword.name,
                                  trimmedValue
                                ); // Update form state with trimmed value
                                handleOldPasswordChange(trimmedValue); // Optionally call your handler to manage the state if needed
                              }}
                            />
                            <i
                              onClick={() => setOldShowPass(!showOldPass)}
                              className={
                                showOldPass
                                  ? "icon icon-eye-fill"
                                  : "icon icon-eye-slash-fill"
                              }
                            ></i>
                          </div>
                        </div>
                        <div className="texFeildWrapper mb-3">
                          <div className="d-flex">
                            <Label className="lable">{t("NEW_PASSWORD")}</Label>
                            <span className="redStar mx-2">*</span>
                          </div>
                          <div className="passWrapper">
                            <TextField
                              formMethod={formMethod}
                              rules={changePasswordForm.newPassword.validate}
                              name={changePasswordForm.newPassword.name}
                              multiErrorFields={multiErrorFields}
                              errors={formMethod?.formState.errors}
                              maxLength={16}
                              passwordType={true}
                              disabled={loading}
                              type={showPass ? "text" : "password"}
                              placeholder={t("ENTER_NEW_PASSWORD")}
                              onChange={(value) => {
                                formMethod?.watch("newPassword") &&
                                  formMethod.trigger("newPassword");

                                const trimmedValue = value.target.value?.trim(); // Trim spaces
                                formMethod.setValue(
                                  changePasswordForm.newPassword.name,
                                  trimmedValue
                                ); // Update form state with trimmed value
                                handleNewPasswordChange(trimmedValue); // Optionally call your handler to manage the state if needed
                              }}
                              triggerValidation={(fieldName) => {
                                if (fieldName === "newPassword") {
                                  formMethod.trigger("confirmPassword"); // Revalidate confirmPassword when newPassword changes
                                }
                              }}
                            />
                            <i
                              onClick={() => setShowPass(!showPass)}
                              className={
                                showPass
                                  ? "icon icon-eye-fill"
                                  : "icon icon-eye-slash-fill"
                              }
                            ></i>
                          </div>
                        </div>

                        <div className="texFeildWrapper mb-3">
                          <div className="d-flex">
                            <Label className="lable">
                              {t("CONFIRM_PASSWORD")}
                            </Label>
                            <span className="redStar mx-2">*</span>
                          </div>
                          <div className="passWrapper">
                            <TextField
                              formMethod={formMethod}
                              rules={{
                                required: true,
                                validate: {
                                  matchPassword: (value: string) =>
                                    value?.trim() ===
                                      formMethod
                                        ?.watch("newPassword")
                                        ?.trim() ||
                                    t("BOTH_PASSWORD_MUST_BE_MATCH"),
                                },
                              }}
                              name={changePasswordForm.confirmPassword.name}
                              errors={formMethod?.formState.errors}
                              passwordType={true}
                              type={showPassConfirm ? "text" : "password"}
                              placeholder={t("CONFIRM_PASSWORD")}
                              disabled={loading}
                              onChange={(e) => {
                                formMethod?.watch("confirmPassword") &&
                                  formMethod.trigger("confirmPassword");

                                const trimmedValue = e.target.value?.trim(); // Trim spaces
                                formMethod.setValue(
                                  changePasswordForm.confirmPassword.name,
                                  trimmedValue
                                ); // Update form state with trimmed value
                                handleConfirmPasswordChange(trimmedValue); // Optionally call your handler to manage the state if needed
                              }}
                            />
                            <i
                              onClick={() =>
                                setShowPassConfirm(!showPassConfirm)
                              }
                              className={
                                showPassConfirm
                                  ? "icon icon-eye-fill"
                                  : "icon icon-eye-slash-fill"
                              }
                            ></i>
                          </div>
                        </div>
                      </div>
                      <div className="submitDiv">
                        <CustomButton
                          className="btn btn-danger text-white btn-lg w-100 text-center justify-content-center"
                          type="submit"
                          title={
                            formMethod?.formState.isValid
                              ? t("UPDATE")
                              : t("CHANGE_PASSWORD")
                          }
                          loading={loading}
                          disabled={!formMethod?.formState.isValid}
                        />
                      </div>
                    </>
                  );
                }}
              </HookForm>
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  );
};

export default ChangePassword;
